export class TranslatorListener {
    public static bindLanguageSelectChange(select: HTMLSelectElement, onChange: (event: Event) => void): void {
        select.addEventListener("change", onChange);
    }

    public static bindLanguageOptionChange(input: HTMLInputElement, onChange: (event: Event) => void): void {
        input.addEventListener("change", onChange);
    }

    public static bindContentInserted(onInserted: () => void): void {
        document.addEventListener("app:content:inserted", onInserted);
    }
}
